import React, {useState} from "react";
import {observer} from "mobx-react";
import {Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography} from "@mui/material";
import Utility from "../../Utility";
import {useStores} from "../../Hooks";
import '../ProcedureDashboard/procedureDashboard.scss';

const baseUrl = Utility.getBaseUrl();

const EmbedProcedureModal = observer(() => {
    const {generalStore, modalStore} = useStores();

    const [width, setWidth] = useState(640);
    const [height, setHeight] = useState(385);

    const closeModal = () => {
        modalStore.isEmbedProcedureModalOpen = false;
        modalStore.modalData.embedId = "";
    };

    const copyLink = async () => {
        await navigator.clipboard.writeText(getIframeLink());
        modalStore.showSuccessMessage(generalStore.translate('linkCopied'));
        closeModal();
    };

    const getIframeLink = () => {
        return `<!--suppress HtmlDeprecatedAttribute -->
<iframe width="${width}" height="${height}" src="${baseUrl}/run/${generalStore.workspace}/1/${modalStore.modalData.embedId}" frameborder="0" allowfullscreen></iframe>`;
    }

    return (
        <Dialog open={modalStore.isEmbedProcedureModalOpen} onClose={closeModal}
                maxWidth={false}>
            <div className="embed-container">
                <iframe width={width} height={height}
                        src={`/run/${generalStore.workspace}/0/${modalStore.modalData.embedId}`}
                        frameBorder="0" allowFullScreen
                        title='run'
                />
                <div className="embed-details">
                    <DialogTitle className="embed-title">{generalStore.translate('embedProcedurePlayer')}</DialogTitle>
                    <DialogContent>
                        <Typography className='embed-link' variant="body1" gutterBottom>
                            {getIframeLink()}
                        </Typography>
                        <div className="embed-options">
                            <div className="embed-options-title">{generalStore.translate('embedOptions')} <span
                                className="embed-options-detail">({generalStore.translate('clickToModify')})</span>
                            </div>
                            <div className="input-embed">
                                <span>{generalStore.translate('height')}: </span>
                                <input className="input-embed-proportion" type="number" value={height}
                                       onChange={(e) => setHeight(Number(e.target.value))}/>
                            </div>
                            <div className="input-embed">
                                <span>{generalStore.translate('width')}: </span>
                                <input className="input-embed-proportion" type="number" value={width}
                                       onChange={(e) => setWidth(Number(e.target.value))}/>
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions className="embed-actions">
                        <Button color="primary" onClick={copyLink}
                                active={!!modalStore.modalData.embedId}>{generalStore.translate('copy')}</Button>
                        <Button color="warning" onClick={closeModal}>{generalStore.translate('cancel')}</Button>
                    </DialogActions>
                </div>
            </div>
        </Dialog>
    );
})

export default EmbedProcedureModal;
